import {useParams} from "react-router-dom";
import ModifyImage from "~/apps/cartario/components/ModifyImage.tsx";

const ImageEdit = () => {
    const { id } = useParams<{ id: string; type: string; }>();
    return (
        <>
            <ModifyImage
                publicId={id}
                editorStyle="advanced"
            />
        </>
    );
}

export default ImageEdit;